module.exports = __webpack_public_path__ + "img/portalmanagement_audit_accesses.31517c39.png";